export const DEV_ENV_TAGS = ['dev', 'amplifyapp', 'frvph0nt']
export const PROD_ENV_TAGS = ['prod', 'q4event.xanadu.ai', 'codecamp.xanadu.ai']
export const STAGE_ENV_TAGS = [
  'staging',
  'stage',
  'luckydumpling.staging.codecamp.xanadu.ai',
]
export const CONSENT_COOKIE = 'consent-cookie'
